import { StateUser, UserStatusLogout } from "@/store/user/types_user";
import { ActionContext } from "vuex";
import { RootState } from "@/store";
import urls from "@/constants/urls";
import router from "@/router";
import { ROUTES } from "@/constants/routes";
export const user_store = {
  state: {
    sessionId: "",
    webId: "",
    userStatusLogout: UserStatusLogout.initial,
  },
  mutations: {
    setSessionId(state: StateUser, sessionId: string): void {
      state.sessionId = sessionId;
    },
    setUserStatusLogout(state: StateUser, status: UserStatusLogout): void {
      state.userStatusLogout = status;
    },
    setWebId(state: StateUser, webId: string): void {
      state.webId = webId;
    },
  },
  actions: {
    initialiseStore(context: ActionContext<StateUser, RootState>): void {
      if (localStorage.getItem("sessionId")) {
        context.commit("setSessionId", localStorage.getItem("sessionId"));
      }
      if (localStorage.getItem("webId")) {
        context.commit("setWebId", localStorage.getItem("webId"));
      }
    },
    saveSessionId(
      context: ActionContext<StateUser, RootState>,
      sessionId: string
    ): void {
      localStorage.setItem("sessionId", sessionId);
      context.commit("setSessionId", sessionId);
    },
    saveWebId(
      context: ActionContext<StateUser, RootState>,
      webId: string
    ): void {
      localStorage.setItem("webId", webId);
      context.commit("setWebId", webId);
    },
    logout(context: ActionContext<StateUser, RootState>): void {
      context.commit("setUserStatusLogout", UserStatusLogout.loading);
      fetch(urls.url_to_logout + context.state.sessionId, {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
        .then((response) => {
          if(response.status===401){
            router.push(ROUTES.SESSION_EXPIRED.path);
            return;
          }
          if (!response.ok) {
            throw Error();
          }
          return response.json();
        })
        .then(() => {
          context.commit("setSessionId", "");
          localStorage.removeItem("sessionId");
          localStorage.removeItem("webId");
          context.commit("setUserStatusLogout", UserStatusLogout.success);
        })
        .catch(() => {
          context.commit("setUserStatusLogout", UserStatusLogout.fail);
        });
    },
  },
  getters: {
    getSessionId(state: StateUser): string {
      return state.sessionId;
    },
    getWebId(state: StateUser): string {
      return state.webId;
    },
    isAuthenticated(state: StateUser): boolean {
      return !(state.sessionId === "");
    },
    getUserStatusLogout(state: StateUser): UserStatusLogout {
      return state.userStatusLogout;
    },
  },
};
